import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; 2024 Ahmad Hammoud. All rights reserved.</p>
          <p>Quality Assurance Engineer | Dedicated to Excellence in Software Testing</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

